import { VariableType } from 'json-to-graphql-query';

import { PaymentPack } from '@/interfaces/paymentPack';
import { EntityResource } from './entity.resource';

/**
 * Resource paczek płatności
 *
 * @export
 * @class PaymentPackResource
 * @extends {EntityResource<PaymentPack>}
 */
export class PaymentPackResource extends EntityResource<PaymentPack> {
  public getFields = {
    id: true,
    number: true
  };

  public listFields = {
    id: true,
    created: true,
    externalId: true,
    number: true,
    structure: {
      id: true,
      name: true
    },
    systemNumbers: true
  };

  protected listVariables = { filters: 'PaymentPackFilters!' };

  constructor() {
    super({ entityName: 'paymentPack' });
  }

  /**
   * Przesyła paczkę do MDOK
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof PaymentPackResource
   */
  public sendToMdok(id: number): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!' },
        paymentListSendToMdok: { __args: { id: new VariableType('id') } }
      }
    });
    return this.mutation({ mutation, variables: { id } }, 'paymentListSendToMdok');
  }
}

export const paymentPackResource = new PaymentPackResource();
